<template>
  <div class="root-box">
    <el-radio-group v-model="pageName" size="small" style="margin-bottom: 12px" @change="onPageChange">
      <el-radio-button label="总览"></el-radio-button>
      <el-radio-button label="明细"></el-radio-button>
    </el-radio-group>
    <award-sum v-if="pageName === '总览'" ref="summary" />
    <award-detail v-if="pageName === '明细'" ref="detail" />
  </div>
</template>

<script>
import awardSum from "./summary";
import awardDetail from "./detail";

export default {
  components: {
    awardSum,
    awardDetail
  },
  data() {
    return {
      pageName: "总览"
    };
  },
  mounted() {
    this.query();
  },
  methods: {
    query() {
      this.$nextTick(() => {
        const ref = this.pageName === "总览" ? this.$refs.summary : this.$refs.detail;
        if (ref && ref.query) {
          ref.query(this.pageName === "明细" ? 1 : undefined);
        }
      });
    },
    onPageChange() {
      this.query();
    }
  }
};
</script>

<style scoped></style>
